package feature.app

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch

open class AppViewModel {

    private val appRepository = AppStateHandler.shared().repository
    val isLoading: StateFlow<Boolean>
        get() = appRepository.isLoading

    fun startLoading() {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            appRepository.isLoadingState.emit(true)
        }
    }

    fun stopLoading() {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            appRepository.isLoadingState.emit(false)
        }
    }

    open fun changeSearchQuery(value: String) {
        
    }

    open fun performSearch(value: String) {

    }
}